export const SUPPORTED_VIDEO_GEN_MARKETPLACES = ["USA", "CA", "MX"];
